module.exports = __webpack_public_path__ + "img/page4.e1c03de7.png";